/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {getters} from '@/store/modules/user-session/getters';
import {actions} from '@/store/modules/user-session/actions';
import {mutations} from '@/store/modules/user-session/mutations';
import {UserSession, UserSessionStateInterface} from '@/store/modules/user-session/types';

/**
 * The user session store module.
 *
 * This module is imported by vuex as a representation of the user session.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export const state: UserSessionStateInterface = {
    session: new UserSession(),
};

const namespaced: boolean = true;

export const userSessionModule: Module<UserSessionStateInterface, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
